import { jsx as _jsx } from "react/jsx-runtime";
import UIImage from 'UIComponents/image/UIImage';
import imageUrls from '../images/imageUrls';
import { getIsMobile } from '../utils/deviceUtils';
export const ConnectLogo = () => {
  const isMobile = getIsMobile();
  const url = isMobile ? imageUrls.connectMobileLogo : imageUrls.connectLogo;
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(UIImage, {
      alt: "Connect",
      className: isMobile ? 'ConnectMobileLogo' : 'ConnectLogo',
      height: 40,
      responsive: false,
      src: url
    })
  });
};